import {Component, Input, OnInit} from '@angular/core';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {OwlMultiSliderConfigService} from 'src/app/home/service/owl-multi-slider-config.service';
import {StoryPreview} from 'src/app/story/interface/story-preview';

@Component({
  selector: 'fb-product-content-slider-light',
  templateUrl: './product-content-slider-light.component.html',
  styleUrls: ['./product-content-slider-light.component.scss']
})
export class ProductContentSliderLightComponent implements OnInit {

	@Input() id:string = '';
	@Input() storyPreviewForLight: StoryPreview[] = []
	public customOptions: OwlOptions = OwlMultiSliderConfigService.owlOptionsSingleSlide;

	constructor(
	) {
	}


	public ngOnInit(): void {
	}

}
